import { AUTHOR } from "@/lib/site";

export const Footer = () => {
    return (
        <footer
            data-testid="footer"
            className="relative border-t border-[#1E1E28] pt-20 pb-12"
        >
            <div className="max-w-6xl mx-auto px-6 md:px-12">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8">
                    <div>
                        <div className="font-display text-3xl font-extrabold tracking-tight text-[#F5F5F5]">
                            DEGASPERIN <span className="text-[#3B6FFF]">IA</span>
                        </div>
                        <p className="mt-2 text-[#7A7A90]">
                            {AUTHOR} — Chapecó, SC
                        </p>
                    </div>
                    <div className="text-[#7A7A90] md:text-right">
                        <a
                            href="https://degasperin.ai"
                            className="text-[#94B4FF] hover:text-white transition-colors"
                        >
                            degasperin.ai
                        </a>
                        <p className="mt-2 text-sm">© 2026 Degasperin IA</p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
